/* eslint-disable no-useless-escape */
/* eslint-disable no-template-curly-in-string */
import React, { FC, useEffect, useState } from "react";
import css from "./styles.module.scss";
import { geoItem } from "./types";
import { Button } from "@mui/material";
import cn from "classnames";

interface ICountryCodeProps {
  data: {
    countryData: any;
    value: any;
    handleChangeSelect: any;
    sortCountryDataArray: any;
    search: any;
    setSearch: any;
    filterCountryData: any;
    handleChangeSelectBeforeSearch: any;
    aftereffect: any;
    arabCountry: any;
  };
}

const CountryCode: FC<ICountryCodeProps> = ({
  data: {
    countryData,
    value,
    handleChangeSelect,
    sortCountryDataArray,
    search,
    setSearch,
    filterCountryData,
    handleChangeSelectBeforeSearch,
    aftereffect,
    arabCountry,
  },
}) => {
  const [valueDoubleOrder, setValueDoubleOrder] = useState<boolean>(true);

  const [cookieName,setCookieName] = useState<number | string>('noAccess');

  useEffect(()=>{
    setCookieName(new Date().getTime())
  },[])

  return (
    <>
      <div className={css.fillData}>
        {arabCountry.includes(value.name) ? (
          value.nameLabel
        ) : (
          <label>{value.nameLabel}</label>
        )}
        <input
          type="text"
          name="name"
          placeholder={value.namePlaceholder}
          required
        />
        {arabCountry.includes(value.name) ? (
          value.phoneLabel
        ) : (
          <label>{value.phoneLabel}</label>
        )}
        <input type="tel" placeholder={value.phonePlaceholder} required />
        <button type="submit">{value.buttonSumbitText}</button>
      </div>
      <div className={css.CountryCode}>
        <div className={css.CountryCode_select}>
          <div className={css.CountryCode_controls}>
            <select
              className={css.CountryCode_field}
              onChange={handleChangeSelect}
            >
              {countryData.sort(sortCountryDataArray).map((geo: geoItem) => (
                <option value={geo.name} key={geo.name}>
                  {geo.name}
                </option>
              ))}
            </select>
            <div className={css.CountryCode_search}>
              <input
                type="text"
                placeholder="Введите Гео"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          {search !== "" && (
            <div className={css.CountryCode_searchResult}>
              {filterCountryData &&
                filterCountryData.map((geo: geoItem) => (
                  <Button
                    variant="contained"
                    size="small"
                    color="success"
                    key={geo.name}
                    onClick={(e) => handleChangeSelectBeforeSearch(geo.name)}
                  >
                    {geo.name}
                  </Button>
                ))}
            </div>
          )}
          <div className={css.CountryCode_double}>
            <input
              id="double"
              type="checkbox"
              checked={valueDoubleOrder}
              onChange={() => {
                setValueDoubleOrder(!valueDoubleOrder);
              }}
            />
            <label htmlFor="double">Дубли заявок</label>
          </div>
        </div>
        <div className={css.CountryCode_result}>
          <span>
            {`
      <script>
      (function (m, e, t, r, i, k, a) {
        m[i] =
          m[i] ||
          function () {
            (m[i].a = m[i].a || []).push(arguments);
          };
        m[i].l = 1 * new Date();
        (k = e.createElement(t)),
          (a = e.getElementsByTagName(t)[0]),
          (k.async = 1),
          (k.src = r),
          a.parentNode.insertBefore(k, a);
      })(
        window,
        document,
        "script",
        "https://mc.yandex.ru/metrika/tag.js",
        "ym"
      );
      ym(999, "init", {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
      });
    </script>
    <style>
    input[type="tel"] {
        outline: none;
    }
    a {
        cursor: pointer !important;
    }
    button {
        cursor: pointer !important;
    }
    button:disabled {
        cursor: not-allowed !important;
    }
    </style>
    <script>
    ${
      valueDoubleOrder
        ? `function getCookie(name) {
        var matches = document.cookie.match(
          new RegExp(
            "(?:^|; )" +
              name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
              "=([^;]*)"
          )
        );
        return matches ? decodeURIComponent(matches[1]) : undefined;
      }
     const validateData = (array) => {
        const cookieData = JSON.parse(getCookie(textCookie));
        let signal = true;
        cookieData.forEach((item) => {
          if (
            item.phone === array[0].phone ||
            (item.name === array[0].name && item.phone === array[0].phone)
          ) {
            signal = false;
            return signal;
          }
        });
        return signal;
      };  
      `
        : ""
    }
        
        const code = "`}
          </span>
          <span
            className={cn(css.CountryCode_lighting, {
              _isLight: aftereffect,
            })}
          >{`${value.code}`}</span>
          <span>{`";
          const inputs = document.querySelectorAll('input[type="tel"]');
          inputs.forEach((input) => {
              input.value = "+" + code;
          });

          ${valueDoubleOrder ? `const textCookie = "${cookieName}";` : ""}
          
  
          const lengthMain = `}</span>
          <span
            className={cn(css.CountryCode_lighting, {
              _isLight: aftereffect,
            })}
          >{`${value.minLengthTel}`}</span>
          <span>
            {`;
        const lengthTotal = code.length + lengthMain;
        const forms = document.querySelectorAll("form");
        forms.forEach((form) => {
            const submitBtn = form.querySelector('button[type="submit"]');
            const inputPhone = form.querySelector('input[type="tel"]');
            const inputName = form.querySelector('input[name="name"]');
            if (submitBtn) {   
            submitBtn.disabled = true;
            if (inputPhone) {
                        inputPhone.addEventListener("input", (e) => {
                const plus = e.target.value.includes("+");
                const clearStr =
                (e.target.value[0] === "+" ? "+" : "") +
                e.target.value.replace(/[+]/g, "");
                if (plus) {
                inputPhone.setAttribute("minlength", lengthTotal + 1);
                } else {
                inputPhone.setAttribute("minlength", lengthTotal);
                }

                inputPhone.value = clearStr;

                if (/(\\+`}
          </span>
          <span
            className={cn(css.CountryCode_lighting, {
              _isLight: aftereffect,
            })}
          >{`${value.code}`}</span>
          <span>{`|`}</span>
          <span
            className={cn(css.CountryCode_lighting, {
              _isLight: aftereffect,
            })}
          >{`${value.code}`}</span>
          <span>{`)([0-9]{`}</span>
          <span
            className={cn(css.CountryCode_lighting, {
              _isLight: aftereffect,
            })}
          >{`${value.minLengthTel}`}</span>
          <span>
            {`})/.test(clearStr)) {
                submitBtn.disabled = false;
                inputPhone.style.border = "2px solid green";
                } else {
                submitBtn.disabled = true;
                inputPhone.style.border = "2px solid red";
                }
            });
                }
${
  valueDoubleOrder
    ? 'submitBtn.addEventListener("click", (e) => {e.preventDefault();const formData = [{name: inputName.value,phone: inputPhone.value,},];if (getCookie(textCookie)) {if (validateData(formData)) {let temp = [...formData, ...JSON.parse(getCookie(textCookie))];document.cookie =textCookie + `=${JSON.stringify(temp)};`;form.submit();} else {alert("'+value.doubleOrderAlert+'");setTimeout(()=>{location.reload();},1000)}} else {document.cookie =textCookie + `=${JSON.stringify(formData)}; max-age=604800`;form.submit();}});'
    : ""
} 
           

            }
        });
    </script>    <style>
    html,body {
      scroll-behavior: smooth !important;
    }
  </style>`}
          </span>
        </div>
      </div>
    </>
  );
};

export default CountryCode;
